import {
    CalcVolumetricFlowAction,
    CalVolumetricFlowState, VolumetricFlowCalculatorUnits,
} from 'src/modules/user-input/calcVolumetricFlow/types.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { targetUnits } from 'src/modules/user-input/targetUnits.ts';
import { getUnitByName } from 'src/modules/user-input/getUnitByName.ts';

export const reducer = (
    prevState: CalVolumetricFlowState,
    action: CalcVolumetricFlowAction,
): CalVolumetricFlowState => {
    let newState = { ...prevState };
    if (action.type === 'input') {
        newState = {
            ...newState,
            ...action.payload,
        };
    }
    if (action.type === 'close_modal') {
        newState.currentModal = null;
    }
    if (action.type === 'open_modal') {
        newState.currentModal = action.payload;
    }
    if (action.type === 'transferModalValue') {
        const defaultUnit =
            action.payload.name === 'inlet' || action.payload.name === 'outlet' || action.payload.name === 'maxDp'
                ? targetUnits.dpv100 : targetUnits.volumetricFlow;
        const unitName: keyof VolumetricFlowCalculatorUnits = `${action.payload.name}_u`;
        newState[action.payload.name] = convert(
            action.payload.value,
            action.payload.unit,
            getUnitByName(newState[unitName], defaultUnit),
        );
        newState.currentModal = null;
        newState.kvsTouched = false;
    }
    if (action.type === 'dpmv_change') {
        newState.dpmv = action.payload.value;
        newState.dpmv_u = action.payload.unit.name;
    }
    if (action.type === 'kvs_change') {
        newState.kvs = action.payload;
        newState.kvsTouched = true;
    }
    if (action.type === 'maxDp_change') {
        newState.maxDp = action.payload;
        newState.kvsTouched = false;
    }
    if (action.type === 'v100_change') {
        newState.v100 = action.payload;
        newState.kvsTouched = false;
    }
    if (action.type === 'v100_unit') {
        newState.v100_u = action.payload.name;
        newState.kvsTouched = false;
    }
    if (action.type === 'kvs_unit') {
        newState.kvs = convert(
            newState.kvs,
            getUnitByName(newState.kvs_u, targetUnits.volumetricFlow),
            action.payload,
        );
        newState.kvs_u = action.payload.name;
        newState.kvsTouched = true;
    }
    if (action.type === 'maxDp_unit') {
        newState.maxDp_u = action.payload.name;
        newState.kvsTouched = false;
    }
    if (action.type === 'mass_change') {
        newState.mass = action.payload;
        newState.kvsTouched = false;
    }
    if (action.type === 'inlet_change') {
        newState.inlet = action.payload;
        newState.kvsTouched = false;
    }
    if (action.type === 'outlet_change') {
        newState.outlet = action.payload;
        newState.kvsTouched = false;
    }
    if (action.type === 'mass_unit') {
        newState.mass_u = action.payload.name;
        newState.kvsTouched = false;
    }

    if (action.type === 'inlet_unit') {
        newState.inlet_u = action.payload.name;
        newState.kvsTouched = false;
    }
    if (action.type === 'outlet_unit') {
        newState.outlet_u = action.payload.name;
        newState.kvsTouched = false;
    }

    newState.shouldEmit = JSON.stringify([
        newState.v100,
        newState.kvs,
        newState.dpmv,
        newState.dpmv_u,
        newState.maxDp,
        newState.v100_u,
        newState.kvs_u,
        newState.maxDp_u,
        newState.mass,
        newState.inlet,
        newState.outlet,
        newState.mass_u,
        newState.inlet_u,
        newState.outlet_u,
    ]) !==
    JSON.stringify([
        prevState.v100,
        prevState.kvs,
        prevState.dpmv,
        prevState.dpmv_u,
        prevState.maxDp,
        prevState.v100_u,
        prevState.kvs_u,
        prevState.maxDp_u,
        prevState.mass,
        prevState.inlet,
        prevState.outlet,
        prevState.mass_u,
        prevState.inlet_u,
        prevState.outlet_u,
    ]);
    return newState;
};
